export class Language {
  idLanguage: number;
  code: string;
  selfTitle: string;
  rtl: boolean;
  locked: boolean;

  constructor(
    idLanguage: number,
    code: string,
    selfTitle: string,
    rtl: boolean,
    locked: boolean,
  ) {
    this.idLanguage = idLanguage;
    this.code = code;
    this.selfTitle = selfTitle;
    this.rtl = rtl;
    this.locked = locked;
  }

  static fromRaw(raw: any): Language {
    return new Language(
      raw.idLanguage,
      String(raw.code),
      String(raw.selfTitle),
      Boolean(raw.rtl),
      Boolean(raw.locked),
    );
  }

  clone(): Language {
    return new Language(
      this.idLanguage,
      this.code,
      this.selfTitle,
      this.rtl,
      this.locked,
    );
  }

  toPayload(): any {
    return {
      idLanguage: this.idLanguage,
      code: this.code,
      selfTitle: this.selfTitle,
      rtl: this.rtl,
      locked: this.locked,
    };
  }
}
